<template>
  <div class="module-sub-media">
    <img v-if="data.img" class="module-sub-media-img" :src="data.img"/>
    <div v-if="data.index && !data.img" class="module-sub-media-img" :class="indexClass">
      <!-- <div>{{data.index | pad0}}</div> -->
    </div>
    <div class="module-sub-media-body">
      <div class="module-sub-media-body-name">{{data.name}}</div>
      <div class="module-sub-media-body-value">{{data.value}}</div>
    </div>
    <div class="module-sub-media-label-wrap">
      <CaseLabel :type="typeLabel">{{data.label}}</CaseLabel>
    </div>
  </div>
</template>

<script>
import { CaseLabel } from '@/components'
export default {
  components: {
    CaseLabel
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    isOdd () {
      return this.data.index % 2
    },
    indexClass () {
      if (this.isOdd) {
        return 'odd'
      }
      return 'even'
    },
    typeLabel () {
      if (this.isOdd) {
        return 0
      }
      return 1
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.module-sub-media {
  position: relative;
  @media (--mediaPc) {
    min-height: 65px; /* 48 + 12 + 12 */
    padding: 12px 53px;
  }
  @media (--mediaMobile) {
    min-height: calc(120px / var(--scale));
    padding-top: calc(24px / var(--scale) / 2);
    padding-bottom: calc(24px / var(--scale) / 2);
    padding-left: 40px;
    padding-right: 25px;
  }
  & .module-sub-media-img {
    position: absolute;
    border-radius: var(--borderRadius1);
    @media (--mediaPc) {
      width: 65px;
      height: 65px;
    }
    @media (--mediaMobile) {
      width: calc(120px / var(--scale));
      height: calc(120px / var(--scale));
    }

    & div {
      display: table;
      width: 50%;
      margin: 0 auto;
      text-align: center;
      font-size: var(--textSize1);
      font-weight: bold;
    }
  }
  & .odd {
    background-color: color(var(--colorMain) a(- 80%));
    color: var(--colorMain);
  }
  & .even {
    background-color: color(var(--colorOrange) a(- 80%));
    color: var(--colorOrange);
  }
  & .module-sub-media-body {
    @media (--mediaPc) {
      margin-left: calc(40px + 48px);
      margin-right: calc(77px + 105px + 44px - 53px);
    }
    @media (--mediaMobile) {
      margin-left: calc(120px / var(--scale) + 15px);
      margin-right: 25px;
    }
    & .module-sub-media-body-name {
      word-break: break-all;
      font-size: var(--textSize3);
      font-weight: bold;
      margin-bottom: 14px;
    }
    & .module-sub-media-body-value {
      word-break: break-all;
      color: var(--colorGray0);
    }
  }
  & .module-sub-media-label-wrap {
    position: absolute;
    top: 0;
    right: 0;
    @media (--mediaPc) {
      margin-top: 12px;
      margin-right: 53px;
    }
    @media (--mediaMobile) {
      margin-top: calc(24px / var(--scale) / 2);
      margin-right: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/sub/Media.vue